// extracted by mini-css-extract-plugin
export var standaloneTable = "_h8-0";
export var standaloneTableWithBodyFill = "_h8-1";
export var withExtraHeader = "_h8-2";